import { type } from "../types/types";

export const set_redirect_home = (value) => (dispatch) => {
  dispatch({
    type: type.CHANGE_REDIRECT,
    value,
  });
};
